<template>
  <div class="focus" v-if="Object.keys(cardList).length" v-loading="loading">
    <div class="focus_search">
      <el-input placeholder="请输入专家名" v-model="val" clearable></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    <div class="focus_card">
      <el-card class="box-card" shadow="hover" v-for="(item,index) in cardList" :key="index">
        <el-image
          v-if="!item.ExpertAvatarUrl"
          style="width: 30%;height:100px;    min-width: 100px;"
          :src="item.ExpertAvatarUrl?'/old/public'+item.ExpertAvatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
          fit="contain"
        >
          <div slot="error" class="image-slot">
            <img src="http://expert.ckcest.cn/autoload/images/avatar.png" style='height: 100px;' alt="">
          </div>
        </el-image>
        <el-image
          v-else
          style="width: 30%;height:100px;    min-width: 100px;"
          src="'http://expert.ckcest.cn/autoload/images/avatar.pngl"
          fit="contain"
        >
        </el-image>
        <div class="focus_info">
          <p>{{item.ExpertName}}</p>
          <p>{{item.ExpertOrganization||'暂无机构信息'}}</p>
          <p>{{item.KId?'KID：'+item.KId :'用户暂未被认领'}}</p>
          <p>
            {{item.IsAuthorized ? '授权用户' :''}}
            <el-checkbox v-model="item.checked"></el-checkbox>
          </p>
        </div>
      </el-card>
    </div>

    <pagination
      :total="total"
      :page.sync="pageData.PageIndex"
      :limit.sync="pageData.PageSize"
      :pageSizes="pageSizes"
      :layout="layout"
      @pagination="getPage"
    />
    <div class="cancelFocus">
      <el-button type="danger" @click="delFocus" :loading="loading">取消关注</el-button>
    </div>
  </div>
  <div style="display:flex;height:75vh" v-else>
    <span style="font-size: 20px;margin:auto">暂无关注专家</span>
  </div>
</template>

<script>
import { getExp, delFocus } from '@/api/center'
import Pagination from '@/components/Pagination'
export default {
  name: 'focus',
  components: {
    Pagination
  },
  props: {
    isHttp: {
      type: String
    }
  },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      val: '',
      cardList: [],
      pageData: {
        PageIndex: 1,
        PageSize: 15
      },
      layout: 'sizes, prev, pager, next, jumper',
      pageSizes: [15],
      loading: false
    }
  },
  methods: {
    search () {
      this.pageData.PageIndex = 1
      this.getExp()
    },
    getPage (page) {
      this.pageData.PageIndex = page.page
      this.getExp()
    },

    getExp () {
      this.loading = true
      let data = {
        ExpertName: this.val,
        PageIndex: this.pageData.PageIndex,
        PageSize: this.pageData.PageSize
      }
      getExp(data).then(res => {
        this.total = res.data.Pages.RecordSum
        res.data.Data.forEach((item, index) => {
          res.data.Data[index].checked = false
        })
        this.cardList = res.data.Data
        this.loading = false
      })
    },
    delFocus () {
      let temp = []
      this.cardList.forEach((item, index) => {
        if (item.checked) {
          temp.push(item)
        }
      })
      let data = {
        userExpertFocuseds: temp
      }
      delFocus(data).then(res => {
        if (res.status === 1) {
          this.getExp()
          this.$message.info({
            showClose: true,
            message: '删除成功',
            offset: 200,
            duration: '2000'
          })
        }
      })
    }
  },
  watch: {
    isHttp: {
      deep: true,
      handler (val) {
        if (val === '1') {
          this.getExp()
        }
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
.focus {
  .focus_search {
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    .el-input {
      margin: 0 20px;
      width: 40%;
    }
  }
  .focus_card {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .el-card {
      margin: 1.2%;
      width: 30%;
      .el-card__body {
        display: flex;
        flex-direction: row;
        .focus_info {
          width: 60%;
          margin-left: 10px;
          p {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 2px 0;
            .el-checkbox {
              float: right;
            }
          }
        }
      }
    }
  }
  .cancelFocus {
    margin: 20px;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/focus.vue